// import Attributes from './attribute/PluginSetup'
import ActionSetup from './actions/PluginSetup'
import DataViewers from './dataViewers/PluginSetup'
import ImageCaptureSetup from './imageCapture/PluginSetup'
import ScreensSetup from './screens/PluginSetup'
// import your plugins

const install = ( molten ) => {
  // install plugins
  // Attributes.install( molten )
  // DataViewers.install( molten )
  ScreensSetup.install( molten )
  ActionSetup.install( molten )
  ImageCaptureSetup.install( molten )
  DataViewers.install( molten )

  // BayPerformanceSetup.install( molten )
  // LoginSetup.install( molten )
}

export default { install }
